<div class="icon_header_tf">
    <app-button-icon [imgUrl]="'assets/svg/plus-icon.svg'" [mat-dialog-close]="false"> </app-button-icon>
</div>
<div class='container'>
    <p>Question {{tag}}</p>
    <h1>Update timeframe</h1>
    <app-form-select [(model)]="selected" [list]="timeframes" [isMulitSelect]="false"></app-form-select>
    <app-button-primary text="Save" [mat-dialog-close]="selected.value"></app-button-primary>
    <app-button-secondary [isGreen]="false" buttonText="Cancel" [isText]="true" [mat-dialog-close]="false"></app-button-secondary>
</div>